<template>
    <div id="preview2">



        <div class="container-fluid">
            <div class="container-width">



                <div class="row without_sliders no-gutters">
                    <div class="col-lg-6 col-md-6 col-sm-12 pl-0 pr-0 row-flex">
                        <a href="#" @click.prevent="onView2" class="item item-sec-row" :style="style">


                            <div class="card_col_1">
                                <img  :src="image"  ref="img"  class="card-img">
                            </div>
                            <div class="card-img-out">
                                <h5 class="card-title">{{title}}</h5>

                                <div class="item__gradient" :style="gradientStyle"></div>
                            </div>

                        </a>
                    </div>
                    <!--<teaser2 style-class="col-lg-6 col-md-6 col-sm-12 pl-0 pr-0 pt-2 row-flex" :teaser="getTeaser()"></teaser2>-->
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                </div>
                <div class="row without_sliders no-gutters">
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                </div>




                <div class="row without_sliders no-gutters">

                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex h-100"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3 col-md-3 col-sm-12 pl-0 pr-0 d-flex h-100" :teaser="getTeaser()"></teaser>
                    <teaser2 style-class="col-lg-6 col-md-6 col-sm-12 pl-0 pr-0 d-flex" :teaser="getTeaser()"></teaser2>
                </div>
                <div class="row without_sliders no-gutters">
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                    <teaser style-class="col-lg-3  col-md-3 col-sm-12 pl-0 pr-0 d-flex"  :teaser="getTeaser()"></teaser>
                </div>

                <infinite :offset="teaserOffset"></infinite>



            </div>
            <pixel></pixel>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import teaser from '@/components/teaser.vue'
    import teaserGroup from '@/components/teaser-group.vue'
    import infinite from '@/components/infinite-preview2.vue'
    import pixel from '../components/pixel'
    import FastAverageColor from 'fast-average-color';

    import Teaser from '../components/teaser'
    import Teaser2 from '../components/teaser2'


    export default {

        data(){
            return {
                image : '',
                title : '',
                text : '',
                rubric_id : 0,
                teasers:[],
                teaserOffset:0,
                news:{},

                gradientStyle:{},
                style:{},
                size: 50,
            };
        },
        components: {
            // teaser,
            teaserGroup,
            infinite,
            pixel,
            Teaser,
            Teaser2,

        },
        mounted() {


            let img = this.$refs.img;
            img.crossorigin = '';
            let vue = this;
            img.addEventListener('load', function()
            {
                let fac = new FastAverageColor();
                let height = this.naturalHeight;

                let color = fac.getColor(this, {height: vue.size});

                var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
                vue.style = {
                    background: color.rgb,
                    color:      color.isDark ? 'white' : 'black',
                };

                vue.gradientStyle  = {background: 'radial-gradient(123% 500% at 92%, ' +
                        'rgba(' + colorEnd + ') 39%, ' + color.rgba + ' 73%)'};
            }, false)



            this.Helper.getArticle(this.$route.query.utm_content, this.$route.query)
                .onSuccess((response)=>{
                    this.title = response.data.title;
                    this.image = response.data.image_rectangle;
                    this.text = response.data.text;
                    this.rubric_id = response.data.rubric_id;
                    this.news = response.data;

                })
                .onFail((error)=>{
                    console.log(error)
                });

            this.Helper.getTeasers(this, 13, this.teaserOffset, 1)
                .onSuccess((response)=>{
                    this.teasers = response.data;
                    this.teaserOffset = 13;
                })
                .onFail((error)=>{
                    console.log(error)
                })
        },
        methods: {
            getTeasers (amount) {
                return this.Helper.getManyTeaser(this.teasers, amount);
            },

            getTeaser () {
                return this.Helper.getOneTeaser(this.teasers);
            },

            onView2() {
                this.Helper.newsPreviewClick(this, this.news, 'view2');
            },

        }
    }
</script>


<style scoped>

</style>